@if (showOptionsForBothApplicants()) {
    <div class="ap-margin-bottom-3">
        {{ 'income.starters-dispensation.button-group.title.both' | apContent }}
    </div>
}
@if (showOptionsForMainApplicantOnly()) {
    <div class="ap-margin-bottom-3">
        {{ 'income.starters-dispensation.button-group.title.main-applicant' | apContent }}
    </div>
}
@if (showOptionsForCoApplicantOnly()) {
    <div class="ap-margin-bottom-3">
        {{ 'income.starters-dispensation.button-group.title.co-applicant' | apContent }}
    </div>
}
<ap-button-group id="startersDispensation" [formControl]="mainApplicantControl" (buttonGroupClicked)="onButtonGroupClicked($event)">
    @if (showOptionsForBothApplicants()) {
        <ap-button-group-item
            label="{{ 'income.starters-dispensation.type.button-group.no' | apContent }}"
            value="{{ startersDispensation.NO_BOTH_APPLICANTS }}"
        ></ap-button-group-item>
        <ap-button-group-item
            label="{{ 'income.starters-dispensation.type.button-group.yes-one-of-us' | apContent }}"
            value="{{ startersDispensation.YES_ONE_OF_APPLICANTS }}"
        ></ap-button-group-item>
        <ap-button-group-item
            label="{{ 'income.starters-dispensation.type.button-group.yes-both' | apContent }}"
            value="{{ startersDispensation.YES_BOTH_APPLICANTS }}"
        ></ap-button-group-item>
        <ap-button-group-item
            label="{{ 'income.starters-dispensation.type.button-group.unknown' | apContent }}"
            value="{{ startersDispensation.UNKNOWN_BOTH_APPLICANTS }}"
        ></ap-button-group-item>
    }
    @if (showOptionsForMainApplicantOnly()) {
        <ap-button-group-item
            label="{{ 'income.starters-dispensation.type.button-group.no' | apContent }}"
            value="{{ startersDispensation.NO_MAIN_APPLICANT }}"
        ></ap-button-group-item>
        <ap-button-group-item
            label="{{ 'income.starters-dispensation.type.button-group.yes' | apContent }}"
            value="{{ startersDispensation.YES_MAIN_APPLICANT }}"
        ></ap-button-group-item>
        <ap-button-group-item
            label="{{ 'income.starters-dispensation.type.button-group.unknown' | apContent }}"
            value="{{ startersDispensation.UNKNOWN_MAIN_APPLICANT }}"
        ></ap-button-group-item>
    }
    @if (showOptionsForCoApplicantOnly()) {
        <ap-button-group-item
            label="{{ 'income.starters-dispensation.type.button-group.no' | apContent }}"
            value="{{ startersDispensation.NO_CO_APPLICANT }}"
        ></ap-button-group-item>
        <ap-button-group-item
            label="{{ 'income.starters-dispensation.type.button-group.yes' | apContent }}"
            value="{{ startersDispensation.YES_CO_APPLICANT }}"
        ></ap-button-group-item>
        <ap-button-group-item
            label="{{ 'income.starters-dispensation.type.button-group.unknown' | apContent }}"
            value="{{ startersDispensation.UNKNOWN_CO_APPLICANT }}"
        ></ap-button-group-item>
    }
</ap-button-group>
